/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { SettingsUpdateConnectionMutationRequest, SettingsUpdateConnectionMutationResponse, SettingsUpdateConnectionPathParams } from "../models/SettingsUpdateConnection";

export function getSettingsUpdateConnectionUrl(station: SettingsUpdateConnectionPathParams["station"], platform: SettingsUpdateConnectionPathParams["platform"]) {
  const res = { method: 'PATCH', url: `/connections/${station}/${platform}/settings` as const }
  return res
}

/**
 * @description Updates the connection settings for a specific platform. Settings structure varies by platform.
 * @summary Update connection settings for a station
 * {@link /connections/:station/:platform/settings}
 */
export async function settingsUpdateConnection(station: SettingsUpdateConnectionPathParams["station"], platform: SettingsUpdateConnectionPathParams["platform"], data: SettingsUpdateConnectionMutationRequest, config: Partial<RequestConfig<SettingsUpdateConnectionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SettingsUpdateConnectionMutationResponse, ResponseErrorConfig<Error>, SettingsUpdateConnectionMutationRequest>({ method : "PATCH", url : getSettingsUpdateConnectionUrl(station, platform).url.toString(), data : requestData, ... requestConfig })
  return res.data
}